import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/dentlab/src/lib/util";

const Collapsible = ({
	className,
	...props
}: React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Root>) => (
	<CollapsiblePrimitive.Root
		className={cn("border-y border-gray-200 pb-1.5 pt-2", className)}
		{...props}
	/>
);

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleTriggerStandard = ({
	className,
	children,
	open,
	icon,
	...props
}: React.ComponentPropsWithoutRef<typeof CollapsibleTrigger> & {
	open: boolean;
	icon?: React.ReactNode;
}) => {
	return (
		<CollapsibleTrigger
			className={cn(
				"flex flex-row gap-2 items-center justify-between focus:text-blue-500 focus:outline-none w-full px-4 text-sm",
				className
			)}
			{...props}
		>
			<div className="flex items-center gap-2">
				{icon && (
					<div className="h-3.5 w-3.5 flex items-center justify-center">
						{icon}
					</div>
				)}
				{children}
			</div>
			{open ? (
				<ChevronDown className="h-4 w-4 shrink-0 transition-transform duration-200" />
			) : (
				<ChevronUp className="h-4 w-4 shrink-0 transition-transform duration-200" />
			)}
		</CollapsibleTrigger>
	);
};

const CollapsibleContent = ({
	className,
	...props
}: React.ComponentPropsWithoutRef<
	typeof CollapsiblePrimitive.CollapsibleContent
>) => (
	<CollapsiblePrimitive.CollapsibleContent
		className={cn("px-4 py-2", className)}
		{...props}
	/>
);

export {
	Collapsible,
	CollapsibleTrigger,
	CollapsibleContent,
	CollapsibleTriggerStandard,
};
